module.exports = __webpack_public_path__ + "img/icn_entrega_orders.9649a160.svg";